import { WorkspaceModel } from '@database/central';

export interface WorkFileAppModel extends WorkspaceModel {
	isExpanded: boolean;
}
